import { getStoredTicket, getStoredTicketId } from '../utils/ticket';

/** Gallery-kiosk shim — Creative Studio shop helpers expect these. */
export function readCanvasSession() {
  const ticket = getStoredTicket();
  const ticketId = getStoredTicketId();
  if (!ticket && !ticketId) return null;
  return {
    ticket: ticket || null,
    ticketId: ticketId || '',
  };
}

export function readStoredTicket() {
  return getStoredTicket();
}
